module.exports = __webpack_public_path__ + "img/pica4.a0a3c443.png";